// Common validation utilities used across components

// Email validation
export const validateEmail = (value) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!value) return "Email is required.";
  if (!emailRegex.test(value)) return "Please enter a valid email.";
  return "";
};

// Name validation (letters only)
export const validateName = (value, fieldName = "Name") => {
  if (!value) return `${fieldName} is required.`;
  if (!/^[a-zA-Z]+$/.test(value)) return `${fieldName} must contain only letters.`;
  return "";
};

// Password validation
export const validatePassword = (value) => {
  if (!value) return "Password is required.";
  if (value.length < 6) return "Password must be at least 6 characters long.";
  if (!/[A-Z]/.test(value)) return "Password must contain at least one uppercase letter.";
  if (!/[0-9]/.test(value)) return "Password must contain at least one number.";
  return "";
};

// Confirm password validation
export const validateConfirmPassword = (value, password) => {
  if (!value) return "Please confirm your password.";
  if (value !== password) return "Passwords do not match.";
  return "";
};

// Phone number validation
export const validatePhoneNumber = (value) => {
  if (!value) return ""; // Phone number is optional
  const cleanValue = value.replace("-", "");
  if (!/^\d{7}$/.test(cleanValue)) {
    return "Phone number must be exactly 7 digits (e.g., 555-4567).";
  }
  return "";
};

// Calculate password strength
export const calculatePasswordStrength = (value) => {
  let strength = 0;
  if (value.length >= 6) strength += 1;
  if (/[A-Z]/.test(value)) strength += 1;
  if (/[0-9]/.test(value)) strength += 1;
  if (/[^a-zA-Z0-9]/.test(value)) strength += 1;
  return strength;
};

// Get password strength text
export const getPasswordStrengthText = (strength) => {
  switch (strength) {
    case 1:
    case 2:
      return "Weak";
    case 3:
      return "Decent";
    case 4:
      return "Strong";
    default:
      return "";
  }
}; 